<template>
  <BaseDetailLayout
    :title="`Order Details   ( ${orderDetails.reference_number} )`"
    :isBackBtnVisible="false"
    contentStyle="height: calc(100vh - 62px)"
  >
    <template #detail>
      <div class="main-order-tracking-layout background_color">
        <v-row class="h-100 ma-0">
          <v-col cols="12" md="4" lg="4" class="d-flex flex-column pr-2">
            <v-card
              color="secondary"
              class="rounded-lg card-box-shadow mb-2"
              elevation="0"
            >
              <v-card-title class="px-2 py-2">
                <v-row no-gutters class="pa-2" v-if="orderDetails">
                  <v-col cols="12" v-if="orderDetails.status == 'unassigned'">
                    <div
                      v-if="
                        orderDeliveryDetails.order_details &&
                        orderDeliveryDetails.order_details
                          .estimated_delivery_date_time
                      "
                    >
                      <h4 class="white--text">Estimated Delivery Date</h4>
                      <h5 class="white--text">
                        {{
                          orderDeliveryDetails.order_details
                            .estimated_delivery_date_time
                        }}
                      </h5>
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="orderDetails.status == 'delivered'">
                    <div
                      v-if="
                        orderDeliveryDetails.order_details &&
                        orderDeliveryDetails.order_details.order_delivered_date
                      "
                    >
                      <h4 class="white--text">Order has been deliverd on</h4>
                      <h5 class="white--text">
                        {{
                          orderDeliveryDetails.order_details
                            .order_delivered_date
                        }}
                      </h5>
                    </div>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider class="mx-3" dark></v-divider>
              <v-row class="pa-3" v-if="orderDeliveryDetails">
                <v-col cols="6">
                  <CompanyDetailsSmallCard
                    :text="orderDetails.reference_number"
                    textValue="Order ID"
                  />
                </v-col>
                <v-col cols="6">
                  <CompanyDetailsSmallCard
                    :text="orderDetails.verbose_status"
                    textValue="Order Status"
                  />
                </v-col>
              </v-row>
            </v-card>

            <!-- Order Delay Warning -->
            <v-card
              elevation="0"
              class="rounded-lg card-box-shadow my-2 warning lighten-3"
              v-if="isOrderDelayed"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="1">
                    <span>
                      <v-icon> mdi-alert-circle </v-icon>
                    </span>
                  </v-col>
                  <v-col cols="11">
                    <h4 class="font-weight-bold text_color--text">
                      Order delay by 20 minutes
                    </h4>
                    <h5 class="font-weight-light text_color--text">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Quae, mollitia velit eveniet vero ea eligendi sit.
                    </h5>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>

            <!-- Action -->
            <v-card
              elevation="0"
              class="rounded-lg card-box-shadow mt-2 h-100"
              v-if="orderDetails.status == 'unassigned'"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center">
                    <h6>Actions</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>
                <div>
                  <v-row no-gutters class="px-2">
                    <v-col cols="12">
                      <v-btn
                        block
                        depressed
                        color="primary lighten-1"
                        @click="openCustomerLocationUpdateForm = true"
                      >
                        <v-icon
                          color="text_color lighten-3"
                          small
                          class="mr-1 text_color--text"
                        >
                          mdi-toy-brick-marker
                        </v-icon>
                        Change {{ orderDetails.order_type }} Information
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="pt-2 px-2">
                    <v-col cols="12">
                      <v-btn
                        block
                        depressed
                        color="primary lighten-1"
                        @click="openRescheduleOrderDialog = true"
                      >
                        <v-icon
                          color="text_color lighten-3"
                          small
                          class="mr-1 text_color--text"
                        >
                          mdi-clipboard-text-clock
                        </v-icon>
                        Change Delivery Date
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="pt-2 px-2">
                    <v-col cols="12">
                      <v-btn
                        block
                        depressed
                        color="error lighten-2"
                        @click="openCancelOrderDialog = true"
                      >
                        <v-icon
                          color="text_color lighten-3"
                          small
                          class="mr-1 text_color--text"
                        >
                          mdi-cancel
                        </v-icon>
                        Cancel Order
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card-subtitle>
            </v-card>

            <!-- Driver -->
            <v-card
              elevation="0"
              class="rounded-lg card-box-shadow mt-2 h-100"
              v-if="orderDetails.status == 'assigned'"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters class="pa-2">
                  <v-col cols="12" class="d-flex justify-center py-6">
                    <img :src="userImage" class="profile-class rounded-xl" />
                  </v-col>
                  <v-col cols="8">
                    <CompanyDetailsSmallCard
                      :text="orderDetails.driver_name"
                      textValue="Driver"
                    />
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider class="mx-3"></v-divider>
              <v-card-subtitle>
                <div>
                  <v-row>
                    <v-col cols="6">
                      <CompanyDetailsSmallCard
                        :text="orderDetails.vehicle_number"
                        textValue="Vehicle"
                      />
                    </v-col>
                    <v-col cols="6">
                      <CompanyDetailsSmallCard
                        :text="orderDetails.driver_contact_number"
                        textValue="Contact Number"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-card-subtitle>
            </v-card>

            <!-- Order Status Delivered Info -->
            <v-card
              elevation="0"
              class="rounded-lg card-box-shadow my-2"
              v-if="orderDetails.status == 'delivered' && !isSubmitFeedBack"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Feedback</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle>
                <div>
                  <v-row no-gutters class="px-2">
                    <v-col cols="12">
                      <h4 class="font-weight-bold text_color--text">
                        Rate your delivery experience
                      </h4>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="pt-2 px-2">
                    <v-col cols="12">
                      <v-rating
                        v-model="customerFeedBackDetails.rating"
                        color="yellow darken-3"
                        empty-icon="$ratingFull"
                        half-increments
                        hover
                      ></v-rating>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="pt-2 px-2">
                    <v-col cols="12">
                      <h4 class="font-weight-bold text_color--text">Remarks</h4>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="pt-2 px-2">
                    <v-col cols="12">
                      <v-card
                        elevation="0"
                        class="px-2 rounded-lg background_color"
                      >
                        <TextAreaField
                          v-model="customerFeedBackDetails.customer_feedback"
                          label="remarks"
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-3"></v-divider>
                  <v-row no-gutters class="pt-3 px-2">
                    <v-col cols="12" class="text-right">
                      <v-btn color="primary" depressed @click="submitFeedback">
                        Submit
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card-subtitle>
            </v-card>
          </v-col>

          <!-- Order & Item Details -->
          <v-col
            cols="12"
            md="4"
            lg="4"
            class="d-flex flex-column pr-2 pl-2 background_color"
          >
            <v-card
              class="rounded-lg card-box-shadow mb-3 py-2"
              elevation="0"
              ref="orderDetailsElement"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Order Details</h6>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <PrimaryButton
                      id="ordersPOD"
                      :x-small="$vuetify.breakpoint.xs"
                      :small="true"
                      v-if="orderDetails.is_pod_uploaded"
                      btnClass="ma-1 rounded-lg"
                      @click="getOrderAttachmentPODDownload"
                      icon="mdi-file-pdf-box"
                      name="POD"
                    />
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle>
                <div v-if="orderDetails">
                  <div v-for="(value, key, index) in orderDetails" :key="index">
                    <v-row
                      no-gutters
                      class="px-2"
                      v-if="
                        value &&
                        [
                          'id',
                          'status',
                          'segment',
                          'customer_code',
                          'customer_address',
                          'coordinates',
                        ].indexOf(key) == -1
                      "
                    >
                      <v-col cols="5">
                        <h5 class="text-caption text-capitalize">
                          {{ key.replace(/_/g, " ") }}
                        </h5>
                      </v-col>
                      <v-col cols="7">
                        <h5 class="text_color--text text-capitalize">
                          {{ value }}
                        </h5>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-subtitle>
            </v-card>

            <v-card
              class="rounded-lg card-box-shadow mt-2 py-2 h-100"
              elevation="0"
              ref="itemDetailsElement"
              v-if="
                itemDetails &&
                itemDetails.length > 0 &&
                $helper.isCompanyHasItems()
              "
            >
              <v-card-subtitle class="px-2 py-2">
                <div v-if="itemDetails">
                  <v-row no-gutters class="px-2 pb-2">
                    <v-col cols="2" class="d-flex justify-center"> # </v-col>
                    <v-col cols="8">
                      <span class="text-body-2 font-weight-bold"
                        >Item Description</span
                      >
                    </v-col>
                    <v-col cols="2">
                      <span class="text-body-2 font-weight-bold">Quantity</span>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row
                    no-gutters
                    v-for="(item, index) in itemDetails"
                    :key="index"
                    class="pa-2"
                  >
                    <v-col cols="2" class="d-flex justify-center">
                      {{ index + 1 }}
                    </v-col>
                    <v-col cols="8">
                      {{ item.description }}
                    </v-col>
                    <v-col cols="2" class="d-flex justify-center">
                      {{ item.original_quantity }}
                    </v-col>
                  </v-row>
                </div>
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pl-2">
            <v-card
              class="rounded-lg card-box-shadow"
              elevation="0"
              ref="orderTrackingElement"
              id="orderTracking-logs-target"
            >
              <v-card-title class="px-3 py-2">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Order Logs</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="overflow-y-auto"
                style="height: calc(100vh - 140px)"
                v-scroll:#vehicle-logs-target="onOrderTrackingLogsScroll"
              >
                <Logs
                  :logs="orderLogs"
                  v-if="orderLogs && orderLogs.length > 0"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
    <template #dialog>
      <CancelOrderForm
        :data="[$route.params.id]"
        :isOrderTracking="true"
        orderMethod="cancelOrder"
        orderModule="orderTracking"
        v-model="openCancelOrderDialog"
        @refreshList="
          getOrderTrackingDetails($route.params.id);
          getOrderTrackingLogs($route.params.id);
          getOrderTrackingItems($route.params.id);
        "
      />
      <RescheduleOrderForm
        :orderParentObj="orderDetails"
        orderMethod="rescheduleOrder"
        orderModule="orderTracking"
        v-model="openRescheduleOrderDialog"
        @refreshList="
          getOrderTrackingDetails($route.params.id);
          getOrderTrackingLogs($route.params.id);
          getOrderTrackingItems($route.params.id);
        "
      />
      <CustomerLocationUpdateDialog
        v-model="openCustomerLocationUpdateForm"
        :id="$route.params.id"
        @refreshData="
          getOrderTrackingDetails($route.params.id);
          getOrderTrackingLogs($route.params.id);
          getOrderTrackingItems($route.params.id);
        "
      />
    </template>
  </BaseDetailLayout>
</template>

<script>
import Logs from "@/components/BaseComponents/Logs.vue";
import userImage from "@/assets/user.png";
import BaseSmallTripDetail from "@/components/BaseComponents/BaseSmallTripDetail.vue";
import CompanyDetailsSmallCard from "@/components/ModuleBasedComponents/Company/CompanyDetailsSmallCard.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import { bus } from "@/main";
import CancelOrderForm from "@/components/ModuleBasedComponents/Order/CancelOrderForm.vue";
import RescheduleOrderForm from "@/components/ModuleBasedComponents/Order/RescheduleOrderForm.vue";
import CustomerLocationUpdateDialog from "@/components/ModuleBasedComponents/CustomerAddress/CustomerLocationUpdateDialog.vue";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";

export default {
  components: {
    Logs,
    BaseSmallTripDetail,
    CompanyDetailsSmallCard,
    TripTooltipWithIcon,
    CancelOrderForm,
    RescheduleOrderForm,
    CustomerLocationUpdateDialog,
    BaseDetailLayout,
  },
  data() {
    return {
      rating: 0,
      userImage,
      tab: 0,
      orderDeliveryDetails: {
        // order_details: {
        //   estimated_delivery_date_time: "01/01/2023, 12:42pm",
        //   order_delivered_date: "01/01/2023, 01:00pm",
        //   order_id: "ORD00030609",
        //   order_status: "Unassigned",
        // },
      },
      orderDetails: {},
      itemDetails: {},
      deliveryPartnerInfo: {},
      orderLogs: [],
      isOrderUnassigned: true,
      isOrderAssigned: false,
      isOrderDelivered: false,
      isOrderDelayed: false,
      isSubmitFeedBack: false,

      selectedCancelOrders: [],
      openCancelOrderDialog: false,
      openRescheduleOrderDialog: false,
      openCustomerLocationUpdateForm: false,
      customerFeedBackDetails: {},
    };
  },
  methods: {
    getOrderAttachmentPODDownload() {
      bus.$emit("showLoader", true);
      this.$api.orderTracking
        .getOrderAttachmentPODDownload({ order: this.orderDetails.id })
        .then((res) => {
          bus.$emit("showLoader", false);
          let generatedPDFBlob = new Blob([res.data], {
            type: "application/pdf",
          });
          var pdfUrl = URL.createObjectURL(generatedPDFBlob);
          window.open(pdfUrl);
        })
        .catch((error) => {
          bus.$emit("showLoader", false);
          console.error(error);
        });
    },
    onOrderTrackingLogsScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isDriverLogsScrollable) {
        this.isDriverLogsScrollable = false;
        this.getDriverLogs();
      }
    },
    getOrderTrackingDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.orderTracking
        .getOrderTrackingDetails(id)
        .then((res) => {
          this.orderDetails = res.data;
          this.isSubmitFeedBack = this.orderDetails?.is_submit_feedback;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    submitFeedback() {
      bus.$emit("showLoader", true);
      this.$api.orderTracking
        .customerFeedBack({
          id: this.$route.params.id,
          data: this.customerFeedBackDetails,
        })
        .then(() => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Your feedback has been successfully submitted!",
            color: "success",
          });
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderTrackingLogs(id) {
      bus.$emit("showLoader", true);
      this.$api.orderTracking
        .getOrderTrackingLogs(id)
        .then((res) => {
          this.orderLogs = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderTrackingItems(id) {
      bus.$emit("showLoader", true);
      this.$api.orderTracking
        .getOrderTrackingItems(id)
        .then((res) => {
          this.itemDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    if (this.$route.params.id) {
      this.getOrderTrackingDetails(this.$route.params.id);
      this.getOrderTrackingLogs(this.$route.params.id);
      this.getOrderTrackingItems(this.$route.params.id);
    }
  },
};
</script>

<style scoped>
.main-order-tracking-layout {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
</style>
